var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-overlay",class:{ visible: _vm.isLoaderVisible }},[_c('div',{staticClass:"spin-loader"})])}
var staticRenderFns = []

export { render, staticRenderFns }